// index.ts - Main entry point for NOVA Chat Widget

// Types
export type {
  NovaWidgetConfig,
  NovaMessage,
  NovaSession,
  NovaError,
  NovaWidgetAPI,
} from './types';

export { DEFAULT_CONFIG } from './types';

// API Client
export { NovaAPIClient } from './api';

// WebSocket Client
export { NovaWebSocket, isWebSocketSupported } from './websocket';
export type { NovaWebSocketConfig, WebSocketMessage, ChatMessage, TypingMessage, ErrorMessage } from './websocket';

// Auth Client
export { NovaAuthClient, NovaLoginModal, PROVIDER_ICONS } from './auth';
export type {
  AuthProvider,
  AuthProviderType,
  AuthProviderInfo,
  AuthUser,
  AuthStatus,
  AuthInitResponse,
  AuthCallbackResponse,
  TelegramLoginData,
  WalletSignatureData,
  LoginModalOptions,
} from './auth';

// Vanilla JS Widget
import { NovaWidgetVanilla, initNovaWidget } from './NovaWidgetVanilla';
export { NovaWidgetVanilla, initNovaWidget };

// For CDN/UMD usage, attach to window
if (typeof window !== 'undefined') {
  const NovaWidget = {
    init: (config: import('./types').NovaWidgetConfig) => new NovaWidgetVanilla(config),
  };
  (window as unknown as Record<string, unknown>).NovaWidget = NovaWidget;
}
